import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import Navbar from "../../../components/layout/Navbar/Navbar";
import Sidebar from "../../../components/layout/Sidebar/Sidebar";
import Header from "../../../components/layout/header/Header";
import CadastrarAlunosContent from "../../../components/Cadastrar-Alunos/CadastrarAlunosContent";
import { getCargoIdSidebar } from "../../../constants/sidebarConfig";
import apiService from "../../../services/api";
import concessionWhite from "../../../assets/concessionWhite.png";

const NAVBAR_HEIGHT = 60;
const SIDEBAR_WIDTH = 300;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #ffffff;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: ${SIDEBAR_WIDTH}px;
  overflow-y: auto;
  height: calc(100vh - ${NAVBAR_HEIGHT}px);
`;

const CadastrarAlunos = () => {
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);
  const location = useLocation();
  const initialSolicitacaoId = location.state?.solicitacaoId ?? null;
  const initialVagaId = location.state?.vagaId ?? null;
  const returnPath = location.state?.returnPath ?? null;

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        setUser(userData);
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error("Erro ao buscar usuário:", err);
      }
    };

    fetchUser();
  }, []);

  return (
    <PageWrapper>
      <Navbar
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
        user={user}
      />
      <ContentWrapper>
        <Sidebar items={sidebarItems} />
        <MainContent>
          <Header
            prefixText="CONCESSÕES / VALIDAÇÕES"
            icon={concessionWhite}
            title="Cadastrar Alunos"
          />
          <CadastrarAlunosContent
            initialSolicitacaoId={initialSolicitacaoId}
            initialVagaId={initialVagaId}
            user={user}
            returnPath={returnPath}
          />
        </MainContent>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default CadastrarAlunos;
